var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 272,
    viewBox: "0 0 448 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2776)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1239_2776",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 11,
    width: 253,
    height: 253
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.971 226.188C357.156 177.003 357.156 97.2572 307.971 48.0717C258.786 -1.11371 179.04 -1.11373 129.855 48.0717C80.6692 97.2572 80.6692 177.003 129.855 226.188C179.04 275.373 258.786 275.373 307.971 226.188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1239_2776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1877 216.364L91.9096 218.645L100.646 227.37L102.924 225.088L94.1877 216.364Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.904 225.108L94.1853 227.386L102.91 218.65L100.628 216.372L91.904 225.108Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2181 239.446L91.94 241.727L100.677 250.451L102.955 248.17L94.2181 239.446Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9223 248.177L94.2036 250.455L102.928 241.719L100.647 239.441L91.9223 248.177Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2295 260.905L91.9514 263.186L100.688 271.91L102.966 269.629L94.2295 260.905Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9475 269.672L94.2288 271.95L102.953 263.213L100.672 260.935L91.9475 269.672Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1556 148.011L91.8775 150.292L100.614 159.017L102.892 156.735L94.1556 148.011Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8555 156.728L94.1368 159.006L102.861 150.27L100.58 147.992L91.8555 156.728Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1559 171.08L91.8778 173.362L100.614 182.086L102.892 179.805L94.1559 171.08Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8791 179.827L94.1604 182.105L102.885 173.369L100.603 171.091L91.8791 179.827Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1791 192.544L91.901 194.826L100.638 203.55L102.916 201.269L94.1791 192.544Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.891 201.291L94.1723 203.569L102.897 194.832L100.615 192.554L91.891 201.291Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1073 79.6151L91.8292 81.8964L100.566 90.6207L102.844 88.3394L94.1073 79.6151Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8184 88.3651L94.0997 90.6432L102.824 81.9066L100.543 79.6285L91.8184 88.3651Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1071 102.727L91.829 105.008L100.566 113.732L102.844 111.451L94.1071 102.727Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8485 111.447L94.1298 113.725L102.854 104.988L100.573 102.71L91.8485 111.447Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1305 124.191L91.8524 126.473L100.589 135.197L102.867 132.916L94.1305 124.191Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8615 132.91L94.1428 135.188L102.867 126.452L100.586 124.174L91.8615 132.91Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0458 11.2669L91.7677 13.5482L100.504 22.2726L102.782 19.9913L94.0458 11.2669Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.776 19.9966L94.0573 22.2747L102.782 13.5381L100.5 11.26L91.776 19.9966Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0769 34.3305L91.7988 36.6118L100.535 45.3362L102.813 43.0549L94.0769 34.3305Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7941 43.0654L94.0754 45.3435L102.8 36.607L100.518 34.3289L91.7941 43.0654Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0824 55.7951L91.8043 58.0764L100.541 66.8008L102.819 64.5195L94.0824 55.7951Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8073 64.5472L94.0886 66.8253L102.813 58.0888L100.532 55.8107L91.8073 64.5472Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.462 216.363L116.184 218.644L124.92 227.368L127.198 225.087L118.462 216.363Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17 225.085L118.451 227.363L127.176 218.627L124.894 216.349L116.17 225.085Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.421 216.339L139.143 218.62L147.879 227.344L150.158 225.063L141.421 216.339Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14 225.066L141.421 227.344L150.146 218.608L147.864 216.33L139.14 225.066Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.349 216.32L162.071 218.601L170.807 227.326L173.086 225.045L164.349 216.32Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.096 225.06L164.378 227.338L173.102 218.602L170.821 216.324L162.096 225.06Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.307 216.325L185.029 218.606L193.766 227.33L196.044 225.049L187.307 216.325Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.004 225.041L187.286 227.319L196.01 218.583L193.729 216.305L185.004 225.041Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.236 216.288L207.958 218.569L216.694 227.294L218.973 225.013L210.236 216.288Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.962 225.035L210.243 227.313L218.967 218.576L216.686 216.298L207.962 225.035Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.493 239.409L116.215 241.69L124.952 250.414L127.23 248.133L118.493 239.409Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.189 248.172L118.47 250.45L127.194 241.713L124.913 239.435L116.189 248.172Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.421 239.408L139.143 241.689L147.879 250.413L150.157 248.132L141.421 239.408Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.127 248.166L141.408 250.444L150.132 241.707L147.851 239.429L139.127 248.166Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.379 239.419L162.101 241.701L170.838 250.425L173.116 248.144L164.379 239.419Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.096 248.146L164.378 250.425L173.102 241.688L170.821 239.41L162.096 248.146Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32 239.388L185.042 241.67L193.779 250.394L196.057 248.113L187.32 239.388Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.023 248.11L187.304 250.388L196.028 241.652L193.747 239.374L185.023 248.11Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.267 239.387L207.989 241.669L216.726 250.393L219.004 248.112L210.267 239.387Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.962 248.104L210.243 250.382L218.967 241.645L216.686 239.367L207.962 248.104Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.498 260.891L116.22 263.172L124.957 271.897L127.235 269.615L118.498 260.891Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.219 269.636L118.5 271.914L127.225 263.177L124.943 260.899L116.219 269.636Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.444 260.89L139.166 263.171L147.903 271.896L150.181 269.614L141.444 260.89Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14 269.63L141.421 271.908L150.146 263.171L147.864 260.893L139.14 269.63Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.385 260.884L162.107 263.165L170.844 271.89L173.122 269.608L164.385 260.884Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.109 269.611L164.39 271.889L173.115 263.152L170.834 260.874L162.109 269.611Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.331 260.865L185.053 263.147L193.79 271.871L196.068 269.59L187.331 260.865Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.048 269.604L187.329 271.883L196.053 263.146L193.772 260.868L185.048 269.604Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.272 260.852L207.994 263.133L216.731 271.858L219.009 269.576L210.272 260.852Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.974 269.568L210.255 271.846L218.979 263.109L216.698 260.831L207.974 269.568Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.413 147.991L116.135 150.272L124.872 158.997L127.15 156.716L118.413 147.991Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.141 156.722L118.422 159L127.146 150.263L124.865 147.985L116.141 156.722Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.372 147.96L139.094 150.241L147.831 158.965L150.109 156.684L141.372 147.96Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.084 156.702L141.365 158.981L150.09 150.244L147.809 147.966L139.084 156.702Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.317 147.959L162.039 150.24L170.776 158.965L173.054 156.683L164.317 147.959Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.022 156.696L164.304 158.974L173.028 150.238L170.747 147.96L162.022 156.696Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.246 147.923L184.968 150.204L193.705 158.928L195.983 156.647L187.246 147.923Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.98 156.672L187.261 158.95L195.985 150.214L193.704 147.936L184.98 156.672Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.193 147.922L207.915 150.203L216.651 158.927L218.929 156.646L210.193 147.922Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.919 156.666L210.201 158.944L218.925 150.208L216.644 147.929L207.919 156.666Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.443 171.073L116.165 173.354L124.902 182.078L127.18 179.797L118.443 171.073Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.158 179.791L118.439 182.069L127.164 173.332L124.882 171.054L116.158 179.791Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.385 171.041L139.106 173.323L147.843 182.047L150.121 179.766L141.385 171.041Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.102 179.771L141.383 182.05L150.107 173.313L147.826 171.035L139.102 179.771Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.33 171.023L162.052 173.304L170.789 182.029L173.067 179.747L164.33 171.023Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.041 179.765L164.322 182.043L173.046 173.307L170.765 171.029L162.041 179.765Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.277 171.022L184.999 173.303L193.735 182.028L196.013 179.746L187.277 171.022Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.98 179.759L187.262 182.037L195.986 173.3L193.705 171.022L184.98 179.759Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.205 171.003L207.927 173.285L216.663 182.009L218.941 179.728L210.205 171.003Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.937 179.752L210.218 182.03L218.942 173.294L216.661 171.016L207.937 179.752Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.448 192.554L116.17 194.836L124.907 203.56L127.185 201.279L118.448 192.554Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17 201.254L118.451 203.532L127.176 194.796L124.894 192.518L116.17 201.254Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.395 192.518L139.117 194.8L147.853 203.524L150.132 201.243L141.395 192.518Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.127 201.248L141.408 203.526L150.132 194.79L147.851 192.511L139.127 201.248Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.353 192.505L162.075 194.786L170.811 203.51L173.089 201.229L164.353 192.505Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.053 201.229L164.334 203.507L173.058 194.771L170.777 192.493L162.053 201.229Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.282 192.487L185.004 194.768L193.74 203.492L196.019 201.211L187.282 192.487Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.992 201.223L187.274 203.501L195.998 194.765L193.717 192.487L184.992 201.223Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.228 192.468L207.95 194.749L216.687 203.474L218.965 201.192L210.228 192.468Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.949 201.217L210.23 203.495L218.954 194.758L216.673 192.48L207.949 201.217Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.382 79.6126L116.104 81.8939L124.841 90.6183L127.119 88.337L118.382 79.6126Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.103 88.3406L118.384 90.6187L127.109 81.8821L124.827 79.604L116.103 88.3406Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.311 79.6119L139.033 81.8932L147.769 90.6175L150.048 88.3363L141.311 79.6119Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.024 88.3346L141.305 90.6127L150.03 81.8761L147.748 79.598L139.024 88.3346Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.257 79.5931L161.979 81.8744L170.716 90.5987L172.994 88.3175L164.257 79.5931Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.982 88.328L164.263 90.6061L172.987 81.8695L170.706 79.5914L161.982 88.328Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.197 79.5621L184.919 81.8434L193.656 90.5677L195.934 88.2865L187.197 79.5621Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.907 88.3096L187.188 90.5876L195.912 81.8511L193.631 79.573L184.907 88.3096Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.157 79.556L207.879 81.8373L216.615 90.5616L218.893 88.2804L210.157 79.556Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.858 88.2904L210.139 90.5685L218.864 81.8319L216.583 79.5538L207.858 88.2904Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.395 102.694L116.117 104.976L124.854 113.7L127.132 111.419L118.395 102.694Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.103 111.427L118.384 113.706L127.109 104.969L124.827 102.691L116.103 111.427Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 102.676L139.063 104.957L147.799 113.681L150.077 111.4L141.341 102.676Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06 111.421L141.341 113.699L150.065 104.963L147.784 102.684L139.06 111.421Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.269 102.675L161.991 104.956L170.728 113.68L173.006 111.399L164.269 102.675Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.98 111.415L164.262 113.693L172.986 104.956L170.705 102.678L161.98 111.415Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.229 102.626L184.95 104.907L193.687 113.631L195.965 111.35L187.229 102.626Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.925 111.378L187.206 113.656L195.931 104.919L193.649 102.641L184.925 111.378Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.156 102.607L207.878 104.889L216.615 113.613L218.893 111.332L210.156 102.607Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.882 111.372L210.164 113.65L218.888 104.913L216.607 102.635L207.882 111.372Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.406 124.171L116.128 126.452L124.864 135.176L127.142 132.895L118.406 124.171Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.128 132.903L118.409 135.182L127.134 126.445L124.852 124.167L116.128 132.903Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.347 124.14L139.068 126.421L147.805 135.146L150.083 132.864L141.347 124.14Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.054 132.885L141.335 135.163L150.06 126.426L147.779 124.148L139.054 132.885Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.293 124.121L162.015 126.403L170.751 135.127L173.029 132.846L164.293 124.121Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.994 132.879L164.275 135.157L172.999 126.42L170.718 124.142L161.994 132.879Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.222 124.103L184.944 126.384L193.68 135.109L195.958 132.827L187.222 124.103Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.968 132.854L187.25 135.133L195.974 126.396L193.693 124.118L184.968 132.854Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.18 124.089L207.902 126.371L216.638 135.095L218.916 132.814L210.18 124.089Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.894 132.836L210.176 135.114L218.9 126.377L216.619 124.099L207.894 132.836Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.321 11.247L116.043 13.5283L124.78 22.2527L127.058 19.9714L118.321 11.247Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.043 19.9905L118.324 22.2686L127.048 13.532L124.767 11.2539L116.043 19.9905Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.262 11.2157L138.984 13.4969L147.72 22.2213L149.998 19.94L141.262 11.2157Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.987 19.9712L141.268 22.2493L149.992 13.5127L147.711 11.2346L138.987 19.9712Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.221 11.2097L161.943 13.491L170.679 22.2153L172.958 19.934L164.221 11.2097Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.938 19.9524L164.219 22.2305L172.944 13.4939L170.662 11.2158L161.938 19.9524Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.166 11.209L184.888 13.4902L193.625 22.2146L195.903 19.9333L187.166 11.209Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.895 19.9287L187.176 22.2068L195.9 13.4702L193.619 11.1921L184.895 19.9287Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.095 11.1902L207.817 13.4714L216.554 22.1958L218.832 19.9145L210.095 11.1902Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.834 19.922L210.115 22.2001L218.84 13.4635L216.558 11.1854L207.834 19.922Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.334 34.3106L116.056 36.5919L124.792 45.3163L127.07 43.035L118.334 34.3106Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.061 43.0588L118.342 45.3369L127.066 36.6004L124.785 34.3223L116.061 43.0588Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28 34.3098L139.002 36.5911L147.738 45.3154L150.016 43.0341L141.28 34.3098Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.018 43.0528L141.299 45.3309L150.023 36.5944L147.742 34.3163L139.018 43.0528Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.238 34.2788L161.96 36.5601L170.697 45.2844L172.975 43.0031L164.238 34.2788Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.943 43.0339L164.224 45.312L172.949 36.5755L170.667 34.2974L161.943 43.0339Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.179 34.2726L184.901 36.5538L193.638 45.2782L195.916 42.9969L187.179 34.2726Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.895 43.0148L187.176 45.2928L195.9 36.5563L193.619 34.2782L184.895 43.0148Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.125 34.2718L207.847 36.5531L216.584 45.2775L218.862 42.9962L210.125 34.2718Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.852 43.0088L210.133 45.2869L218.858 36.5503L216.576 34.2722L207.852 43.0088Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.357 55.7929L116.079 58.0742L124.816 66.7986L127.094 64.5173L118.357 55.7929Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.073 64.5231L118.354 66.8011L127.078 58.0646L124.797 55.7865L116.073 64.5231Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.303 55.7739L139.025 58.0552L147.762 66.7795L150.04 64.4983L141.303 55.7739Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.03 64.5165L141.311 66.7946L150.035 58.058L147.754 55.7799L139.03 64.5165Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.231 55.7552L161.953 58.0365L170.69 66.7609L172.968 64.4796L164.231 55.7552Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.968 64.5099L164.25 66.788L172.974 58.0514L170.693 55.7733L161.968 64.5099Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19 55.7418L184.912 58.0231L193.648 66.7474L195.926 64.4661L187.19 55.7418Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.895 64.4909L187.176 66.769L195.9 58.0325L193.619 55.7544L184.895 64.4909Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.13 55.7359L207.852 58.0172L216.589 66.7416L218.867 64.4603L210.13 55.7359Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.864 64.4548L210.145 66.7329L218.87 57.9964L216.588 55.7183L207.864 64.4548Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.906 216.279L228.628 218.561L237.365 227.285L239.643 225.004L230.906 216.279Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.624 225.018L230.906 227.297L239.63 218.56L237.349 216.282L228.624 225.018Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.852 216.261L251.574 218.542L260.311 227.266L262.589 224.985L253.852 216.261Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.582 225.012L253.863 227.29L262.587 218.554L260.306 216.276L251.582 225.012Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.824 216.26L274.546 218.541L283.282 227.265L285.56 224.984L276.824 216.26Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52 224.981L276.802 227.259L285.526 218.522L283.245 216.244L274.52 224.981Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.752 216.241L297.474 218.523L306.21 227.247L308.488 224.966L299.752 216.241Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.458 224.974L299.74 227.253L308.464 218.516L306.183 216.238L297.458 224.974Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.698 216.205L320.42 218.486L329.156 227.211L331.434 224.929L322.698 216.205Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.434 224.968L322.715 227.246L331.44 218.509L329.158 216.231L320.434 224.968Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.937 239.361L228.659 241.642L237.395 250.367L239.673 248.085L230.937 239.361Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.643 248.105L230.924 250.383L239.648 241.646L237.367 239.368L228.643 248.105Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.864 239.342L251.586 241.624L260.323 250.348L262.601 248.067L253.864 239.342Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.581 248.099L253.862 250.377L262.586 241.64L260.305 239.362L251.581 248.099Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.824 239.311L274.546 241.592L283.282 250.317L285.56 248.035L276.824 239.311Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.525 248.062L276.807 250.34L285.531 241.603L283.25 239.325L274.525 248.062Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.781 239.305L297.503 241.586L306.24 250.311L308.518 248.029L299.781 239.305Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.494 248.043L299.775 250.321L308.5 241.584L306.218 239.306L297.494 248.043Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.71 239.304L320.432 241.586L329.168 250.31L331.446 248.029L322.71 239.304Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.433 248.037L322.714 250.315L331.439 241.579L329.157 239.3L320.433 248.037Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 260.843L228.664 263.124L237.4 271.849L239.678 269.567L230.942 260.843Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.654 269.569L230.936 271.847L239.66 263.11L237.379 260.832L228.654 269.569Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.888 260.807L251.61 263.088L260.347 271.812L262.625 269.531L253.888 260.807Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.594 269.562L253.875 271.84L262.6 263.104L260.318 260.826L251.594 269.562Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.834 260.77L274.556 263.052L283.293 271.776L285.571 269.495L276.834 260.77Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.569 269.539L276.85 271.817L285.574 263.08L283.293 260.802L274.569 269.539Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.774 260.757L297.496 263.038L306.233 271.763L308.511 269.482L299.774 260.757Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.494 269.52L299.775 271.798L308.5 263.061L306.218 260.783L297.494 269.52Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.733 260.769L320.455 263.05L329.192 271.775L331.47 269.493L322.733 260.769Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.428 269.501L322.709 271.779L331.434 263.043L329.152 260.765L320.428 269.501Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.875 147.883L228.597 150.165L237.333 158.889L239.612 156.608L230.875 147.883Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.587 156.655L230.868 158.934L239.593 150.197L237.311 147.919L228.587 156.655Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.816 147.895L251.538 150.176L260.275 158.901L262.553 156.619L253.816 147.895Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.539 156.619L253.821 158.897L262.545 150.16L260.264 147.882L251.539 156.619Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.762 147.876L274.484 150.158L283.221 158.882L285.499 156.601L276.762 147.876Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.46 156.63L276.741 158.908L285.465 150.172L283.184 147.894L274.46 156.63Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69 147.858L297.412 150.139L306.148 158.864L308.426 156.582L299.69 147.858Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.416 156.606L299.697 158.884L308.421 150.148L306.14 147.87L297.416 156.606Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.65 147.844L320.371 150.126L329.108 158.85L331.386 156.569L322.65 147.844Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.361 156.587L322.642 158.865L331.366 150.129L329.085 147.851L320.361 156.587Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.875 170.978L228.597 173.259L237.334 181.983L239.612 179.702L230.875 170.978Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6 179.737L230.881 182.015L239.606 173.278L237.324 171L228.6 179.737Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.833 170.964L251.555 173.245L260.292 181.97L262.57 179.688L253.833 170.964Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.543 179.718L253.825 181.996L262.549 173.259L260.268 170.981L251.543 179.718Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.774 170.958L274.496 173.239L283.232 181.964L285.511 179.682L276.774 170.958Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.495 179.699L276.776 181.977L285.5 173.24L283.219 170.962L274.495 179.699Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72 170.94L297.442 173.221L306.179 181.945L308.457 179.664L299.72 170.94Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.434 179.693L299.715 181.971L308.44 173.235L306.158 170.956L297.434 179.693Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.662 170.908L320.384 173.19L329.121 181.914L331.399 179.633L322.662 170.908Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.379 179.656L322.66 181.934L331.384 173.198L329.103 170.92L320.379 179.656Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.898 192.46L228.62 194.741L237.357 203.465L239.635 201.184L230.898 192.46Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.595 201.201L230.876 203.479L239.6 194.742L237.319 192.464L228.595 201.201Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.839 192.429L251.561 194.71L260.298 203.434L262.576 201.153L253.839 192.429Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.538 201.182L253.819 203.46L262.544 194.724L260.262 192.445L251.538 201.182Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.798 192.423L274.52 194.704L283.257 203.428L285.535 201.147L276.798 192.423Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.508 201.163L276.789 203.441L285.513 194.705L283.232 192.427L274.508 201.163Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.726 192.404L297.448 194.685L306.184 203.41L308.462 201.128L299.726 192.404Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.446 201.157L299.728 203.435L308.452 194.699L306.171 192.42L297.446 201.157Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.672 192.385L320.394 194.667L329.131 203.391L331.409 201.11L322.672 192.385Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.404 201.133L322.685 203.411L331.409 194.674L329.128 192.396L320.404 201.133Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.827 79.548L228.549 81.8292L237.286 90.5536L239.564 88.2723L230.827 79.548Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54 88.2745L230.821 90.5526L239.546 81.8161L237.264 79.538L228.54 88.2745Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.755 79.5116L251.477 81.7928L260.213 90.5172L262.491 88.2359L253.755 79.5116Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.479 88.2685L253.76 90.5466L262.484 81.8101L260.203 79.532L251.479 88.2685Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.714 79.4983L274.436 81.7795L283.172 90.5039L285.451 88.2226L276.714 79.4983Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.441 88.2495L276.722 90.5276L285.446 81.791L283.165 79.513L274.441 88.2495Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.66 79.4796L297.381 81.7609L306.118 90.4852L308.396 88.204L299.66 79.4796Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.379 88.243L299.661 90.5211L308.385 81.7846L306.104 79.5065L297.379 88.243Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.605 79.4788L320.327 81.7601L329.064 90.4845L331.342 88.2032L322.605 79.4788Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3 88.237L322.581 90.5151L331.306 81.7786L329.024 79.5005L320.3 88.237Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84 102.612L228.562 104.893L237.298 113.617L239.576 111.336L230.84 102.612Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.558 111.361L230.839 113.639L239.563 104.903L237.282 102.625L228.558 111.361Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.785 102.593L251.507 104.874L260.243 113.599L262.522 111.317L253.785 102.593Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.514 111.337L253.796 113.615L262.52 104.879L260.239 102.6L251.514 111.337Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.731 102.592L274.453 104.874L283.19 113.598L285.468 111.317L276.731 102.592Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.436 111.331L276.717 113.609L285.441 104.873L283.16 102.595L274.436 111.331Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.672 102.561L297.394 104.842L306.131 113.567L308.409 111.285L299.672 102.561Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.379 111.312L299.661 113.59L308.385 104.854L306.104 102.575L297.379 111.312Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.619 102.542L320.341 104.824L329.077 113.548L331.355 111.267L322.619 102.542Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.336 111.305L322.617 113.583L331.341 104.847L329.06 102.569L320.336 111.305Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.862 124.076L228.584 126.358L237.321 135.082L239.599 132.801L230.862 124.076Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.588 132.808L230.869 135.086L239.594 126.349L237.312 124.071L228.588 132.808Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.809 124.075L251.531 126.357L260.267 135.081L262.545 132.8L253.809 124.075Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.527 132.801L253.808 135.079L262.532 126.343L260.251 124.065L251.527 132.801Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.736 124.074L274.458 126.356L283.195 135.08L285.473 132.799L276.736 124.074Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.448 132.813L276.729 135.091L285.453 126.354L283.172 124.076L274.448 132.813Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.696 124.026L297.418 126.307L306.154 135.031L308.432 132.75L299.696 124.026Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.392 132.776L299.673 135.054L308.398 126.318L306.116 124.04L297.392 132.776Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.624 124.025L320.346 126.306L329.083 135.03L331.361 132.749L322.624 124.025Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.349 132.77L322.631 135.048L331.355 126.311L329.074 124.033L320.349 132.77Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.783 11.1819L228.505 13.4631L237.242 22.1875L239.52 19.9062L230.783 11.1819Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.497 19.9236L230.778 22.2017L239.503 13.4651L237.221 11.187L228.497 19.9236Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.724 11.1508L251.446 13.4321L260.183 22.1565L262.461 19.8752L253.724 11.1508Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.441 19.8874L253.723 22.1655L262.447 13.429L260.166 11.1509L251.441 19.8874Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.652 11.1322L274.374 13.4135L283.111 22.1378L285.389 19.8565L276.652 11.1322Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.38 19.8808L276.661 22.1589L285.386 13.4224L283.104 11.1443L274.38 19.8808Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.598 11.1136L297.32 13.3949L306.057 22.1193L308.335 19.838L299.598 11.1136Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.337 19.8747L299.618 22.1528L308.343 13.4163L306.062 11.1382L297.337 19.8747Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57 11.1128L320.292 13.394L329.028 22.1184L331.306 19.8371L322.57 11.1128Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.294 19.8255L322.575 22.1036L331.299 13.3671L329.018 11.089L320.294 19.8255Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.796 34.2457L228.518 36.527L237.255 45.2513L239.533 42.97L230.796 34.2457Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.515 42.9926L230.796 45.2708L239.521 36.5342L237.239 34.2561L228.515 42.9926Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.754 34.2324L251.476 36.5137L260.213 45.238L262.491 42.9568L253.754 34.2324Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.441 42.9737L253.723 45.2518L262.447 36.5153L260.166 34.2372L251.441 42.9737Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.665 34.196L274.387 36.4773L283.124 45.2017L285.402 42.9204L276.665 34.196Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.399 42.9676L276.68 45.2457L285.405 36.5092L283.123 34.2311L274.399 42.9676Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.611 34.1952L297.333 36.4764L306.07 45.2008L308.348 42.9195L299.611 34.1952Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.355 42.9435L299.637 45.2216L308.361 36.485L306.08 34.2069L297.355 42.9435Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.557 34.1943L320.279 36.4756L329.015 45.1999L331.293 42.9187L322.557 34.1943Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.276 42.955L322.557 45.2332L331.281 36.4966L329 34.2185L320.276 42.955Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.801 55.7098L228.523 57.9911L237.26 66.7154L239.538 64.4342L230.801 55.7098Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.528 64.4563L230.809 66.7344L239.534 57.9978L237.252 55.7197L228.528 64.4563Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.748 55.709L251.47 57.9902L260.206 66.7146L262.484 64.4333L253.748 55.709Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.467 64.4498L253.748 66.7279L262.472 57.9914L260.191 55.7133L251.467 64.4498Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.689 55.6601L274.411 57.9414L283.147 66.6658L285.425 64.3845L276.689 55.6601Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.429 64.4135L276.71 66.6917L285.435 57.9551L283.153 55.677L274.429 64.4135Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.635 55.6598L297.357 57.941L306.093 66.6654L308.371 64.3841L299.635 55.6598Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.349 64.4076L299.631 66.6857L308.355 57.9491L306.074 55.671L297.349 64.4076Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.581 55.6588L320.303 57.9401L329.039 66.6644L331.317 64.3831L322.581 55.6588Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.288 64.4192L322.57 66.6973L331.294 57.9607L329.013 55.6826L320.288 64.4192Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.984 216.209L344.706 218.49L353.443 227.214L355.721 224.933L346.984 216.209Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.687 224.932L346.968 227.21L355.693 218.474L353.411 216.196L344.687 224.932Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.985 239.285L344.707 241.566L353.444 250.291L355.722 248.009L346.985 239.285Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7 248.031L346.981 250.309L355.706 241.573L353.424 239.295L344.7 248.031Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.991 260.749L344.712 263.031L353.449 271.755L355.727 269.474L346.991 260.749Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.713 269.495L346.994 271.773L355.719 263.037L353.437 260.759L344.713 269.495Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.923 147.825L344.645 150.106L353.382 158.83L355.66 156.549L346.923 147.825Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.626 156.581L346.908 158.859L355.632 150.123L353.351 147.845L344.626 156.581Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.936 170.906L344.658 173.188L353.395 181.912L355.673 179.631L346.936 170.906Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.663 179.65L346.944 181.928L355.669 173.192L353.387 170.913L344.663 179.65Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.959 192.371L344.681 194.652L353.418 203.376L355.696 201.095L346.959 192.371Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.675 201.114L346.956 203.392L355.68 194.656L353.399 192.378L344.675 201.114Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.863 79.4587L344.584 81.74L353.321 90.4643L355.599 88.1831L346.863 79.4587Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.585 88.2126L346.866 90.4907L355.591 81.7542L353.309 79.4761L344.585 88.2126Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.875 102.54L344.597 104.822L353.333 113.546L355.611 111.265L346.875 102.54Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.584 111.299L346.865 113.577L355.59 104.841L353.309 102.563L344.584 111.299Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.899 124.005L344.621 126.286L353.358 135.01L355.636 132.729L346.899 124.005Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.597 132.764L346.879 135.042L355.603 126.305L353.322 124.027L344.597 132.764Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.826 11.093L344.548 13.3743L353.285 22.0986L355.563 19.8174L346.826 11.093Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.542 19.8374L346.823 22.1155L355.548 13.3789L353.266 11.1008L344.542 19.8374Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 34.1745L344.579 36.4558L353.316 45.1802L355.594 42.8989L346.857 34.1745Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.56 42.9059L346.841 45.184L355.566 36.4474L353.284 34.1693L344.56 42.9059Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.863 55.639L344.585 57.9203L353.321 66.6446L355.599 64.3634L346.863 55.639Z",
    fill: "#E51E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.572 64.37L346.853 66.6481L355.578 57.9115L353.296 55.6334L344.572 64.37Z",
    fill: "#E51E25"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.061 0H120.456V11.5142H125.061V0Z",
    fill: "#1877F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.061 0H120.456V11.5142H125.061V0Z",
    fill: "#1877F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.061 190.001H120.456V201.516H125.061V190.001Z",
    fill: "#1877F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5148 98.4551H22.0006V103.061H33.5148V98.4551Z",
    fill: "#1877F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5148 98.4551H22.0006V103.061H33.5148V98.4551Z",
    fill: "#1877F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.516 98.4551H212.002V103.061H223.516V98.4551Z",
    fill: "#1877F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1544 27.8827L49.8977 31.1394L58.0395 39.2811L61.2962 36.0244L53.1544 27.8827Z",
    fill: "#1877F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1544 27.8827L49.8977 31.1394L58.0395 39.2811L61.2962 36.0244L53.1544 27.8827Z",
    fill: "#1877F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.488 162.244L184.231 165.501L192.373 173.643L195.629 170.386L187.488 162.244Z",
    fill: "#1877F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0294 162.228L49.8891 170.371L53.1463 173.628L61.2867 165.484L58.0294 162.228Z",
    fill: "#1877F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0294 162.228L49.8891 170.371L53.1463 173.628L61.2867 165.484L58.0294 162.228Z",
    fill: "#1877F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.375 27.878L184.235 36.0211L187.492 39.2772L195.633 31.1341L192.375 27.878Z",
    fill: "#1877F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.043 2.1285L97.5589 3.17786L100.182 14.3892L104.667 13.3398L102.043 2.1285Z",
    fill: "#1877F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.043 2.1285L97.5589 3.17786L100.182 14.3892L104.667 13.3398L102.043 2.1285Z",
    fill: "#1877F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.341 187.139L140.856 188.188L143.48 199.399L147.964 198.35L145.341 187.139Z",
    fill: "#1877F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3474 118.848L24.137 121.476L25.188 125.96L36.3984 123.332L35.3474 118.848Z",
    fill: "#1877F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3474 118.848L24.137 121.476L25.188 125.96L36.3984 123.332L35.3474 118.848Z",
    fill: "#1877F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.345 75.5662L209.134 78.1915L210.184 82.6759L221.395 80.0505L220.345 75.5662Z",
    fill: "#1877F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3728 45.6653L35.9444 49.5787L45.7281 55.6496L48.1565 51.7361L38.3728 45.6653Z",
    fill: "#1877F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3728 45.6653L35.9444 49.5787L45.7281 55.6496L48.1565 51.7361L38.3728 45.6653Z",
    fill: "#1877F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.798 145.852L197.369 149.765L207.153 155.836L209.581 151.923L199.798 145.852Z",
    fill: "#1877F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7553 175.359L67.6828 185.142L71.5958 187.571L77.6684 177.788L73.7553 175.359Z",
    fill: "#1877F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7553 175.359L67.6828 185.142L71.5958 187.571L77.6684 177.788L73.7553 175.359Z",
    fill: "#1877F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.921 13.9277L167.849 23.7103L171.762 26.1394L177.834 16.3567L173.921 13.9277Z",
    fill: "#1877F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7367 6.24233L83.4559 7.94153L87.7039 18.6434L91.9847 16.9442L87.7367 6.24233Z",
    fill: "#1877F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7367 6.24233L83.4559 7.94153L87.7039 18.6434L91.9847 16.9442L87.7367 6.24233Z",
    fill: "#1877F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M157.817 182.855L153.536 184.554L157.784 195.256L162.065 193.557L157.817 182.855Z",
    fill: "#1877F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9561 131.525L28.2542 135.773L29.9534 140.054L40.6553 135.806L38.9561 131.525Z",
    fill: "#1877F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9561 131.525L28.2542 135.773L29.9534 140.054L40.6553 135.806L38.9561 131.525Z",
    fill: "#1877F2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.569 61.4443L204.867 65.6923L206.566 69.973L217.268 65.725L215.569 61.4443Z",
    fill: "#1877F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1763 58.6984L29.3501 62.9265L39.9204 67.492L41.7466 63.2638L31.1763 58.6984Z",
    fill: "#1877F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1763 58.6984L29.3501 62.9265L39.9204 67.492L41.7466 63.2638L31.1763 58.6984Z",
    fill: "#1877F2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M205.623 134.038L203.797 138.266L214.367 142.832L216.193 138.604L205.623 134.038Z",
    fill: "#1877F2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.282 181.792L80.7184 192.363L84.9468 194.189L89.5104 183.617L85.282 181.792Z",
    fill: "#1877F2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.282 181.792L80.7184 192.363L84.9468 194.189L89.5104 183.617L85.282 181.792Z",
    fill: "#1877F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M160.582 7.344L156.018 17.9152L160.246 19.7406L164.81 9.16944L160.582 7.344Z",
    fill: "#1877F2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1243 16.7269L63.3433 19.3567L69.9179 28.8092L73.6989 26.1794L67.1243 16.7269Z",
    fill: "#1877F2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1243 16.7269L63.3433 19.3567L69.9179 28.8092L73.6989 26.1794L67.1243 16.7269Z",
    fill: "#1877F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M175.615 172.698L171.834 175.328L178.408 184.78L182.189 182.15L175.615 172.698Z",
    fill: "#1877F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1856 149.818L38.733 156.392L41.3629 160.173L50.8154 153.599L48.1856 149.818Z",
    fill: "#1877F2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1856 149.818L38.733 156.392L41.3629 160.173L50.8154 153.599L48.1856 149.818Z",
    fill: "#1877F2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M204.17 41.3512L194.717 47.9258L197.347 51.7068L206.8 45.1322L204.17 41.3512Z",
    fill: "#1877F2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9927 80.6766L23.1787 85.2097L34.5116 87.2447L35.3256 82.7116L23.9927 80.6766Z",
    fill: "#1877F2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9927 80.6766L23.1787 85.2097L34.5116 87.2447L35.3256 82.7116L23.9927 80.6766Z",
    fill: "#1877F2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M211.018 114.268L210.204 118.801L221.537 120.836L222.351 116.303L211.018 114.268Z",
    fill: "#1877F2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.731 188.187L102.698 199.52L107.232 200.333L109.265 189L104.731 188.187Z",
    fill: "#1877F2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M104.731 188.187L102.698 199.52L107.232 200.333L109.265 189L104.731 188.187Z",
    fill: "#1877F2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138.294 1.17175L136.261 12.505L140.794 13.3182L142.827 1.98497L138.294 1.17175Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 447.511,
    height: 272,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/BACKGROUND.14d78b72de0843a16fdb9f71fea2be0e.svg";
export { ForwardRef as ReactComponent };